export default {
  state: {
    usuario: null,
    detalleUsuario: null
  },

  mutations: {
    setUsuario(state, newData) {
      state.usuario = newData;
    },

    setDetalleUsuario(state, newData){
      state.detalleUsuario = newData
    }
  },

};
